import { useStaticQuery, graphql } from 'gatsby';

const GlobalQuery = () => {
  return useStaticQuery(graphql`
    query GlobalQuery {
      strapiGlobal {
        footer {
          contactMail
          contactPerson
          contactPersonTitle
          contactUsTitle
          copyrightMessae
          officeHoursTitle
          officeWorkingDays
          officeWorkingTime
          phoneNumber
          phoneText
          websiteTagline
          websiteTaglineLink
          footerMenuTitle
          address {
            data {
              address
            }
          }
          footerContent {
            data {
              footerContent
            }
          }
          footerLinks {
            title
            link
          }
        }
        subscribe {
          title
          tagline
          showSubscribeForm
        }
        socialMediaLinks {
          facebookLink
          instagramLink
          twitterLink
          youtubeLink
          linkedinLink
          tiktokLink
        }
        massTime {
          DailyMassTimings {
            id
            day
            time
            note
          }
          SundayMassTimings {
            day
            time
          }
          dayTitle
          timeTitle
          note {
            data {
              note
            }
          }
        }
        pagePopup {
          title
          slug
          showOnPageLoad
          description {
            data {
              description
            }
          }
          image {
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
        }
        header {
          weeklyMassTimeTitle
          weeklyMassTimeSlug
          headerLinks {
            title
            link
          }
        }
        mainNavLinks {
          title
          link
        }
        footer {
          address {
            data {
              address
            }
          }
        }
      }
      allStrapiPage(sort: { title: ASC }) {
        nodes {
          title
          slug
          strapi_children {
            title
            slug
            strapi_children {
              title
              slug
            }
          }
        }
      }
    }
  `);
};
export { GlobalQuery };
